import { Button, DefaultCard } from '../../components';
import { FaPen, FaUsers } from 'react-icons/fa';
import { GrupoEleitoresResponseType, SummaryCardType } from '../../types';

import { FunctionComponent } from 'react';
import { GruposEleitoresList } from '.';
import { Spinner } from '../../utils';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const GruposEleitoresSummaryCard: FunctionComponent<SummaryCardType<GrupoEleitoresResponseType[]>> = ({
  domain,
  setState,
  idEleicao,
  permiteAlterarDadosEleicao,
  loading = false,
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <DefaultCard
      cardTitle={t('label.grupos_eleitores')}
      mainAction={() => {
        navigate(`/eleicoes/${idEleicao}/grupos-eleitores/alterar`);
      }}
      mainActionName={t('label.gerenciar_grupos_eleitores')}
      mainActionIcon={FaPen}
      empty={domain?.length <= 0}
      emptyIcon={FaUsers}
      emptyMessage={t('texto.nenhum_grupo_eleitores')}
    >
      {loading ? (
        <Spinner />
      ) : domain.length > 0 ? (
        <GruposEleitoresList gruposEleitores={domain} />
      ) : (
        <div className="d-flex  flex-column align-items-center justify-content-center">
          <p>{t('texto.nenhum_grupo_eleitores')}</p>
          {permiteAlterarDadosEleicao && (
            <Button
              title={t('label.cadastrar')}
              onClick={() => {
                navigate(`/eleicoes/${idEleicao}/grupos-eleitores/cadastrar`);
              }}
            />
          )}
        </div>
      )}
    </DefaultCard>
  );
};

export default GruposEleitoresSummaryCard;
